<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true">
      <template slot="actions">
        <vx-input-group>
          <vs-input :placeholder="$t('number')" v-model="callbackNumberFormData.number" />
          <template slot="append">
            <div class="append-text btn-addon">
              <vs-button id="addCallbackNumberButton" color="primary" type="filled" icon-pack="feather" icon="icon-plus" size="small" @click="addCallbackNumber">{{ $t('add_callback_number') }}</vs-button>
            </div>
          </template>
        </vx-input-group>
      </template>
      <vs-divider></vs-divider>
    </vx-card>

    <vx-card id="messageCallbackNumberDataContainer" :title="$t('callback_number')" class="mb-8 vs-con-loading__container">

      <template slot="actions" v-if="showNavTab">
        <shared-messages-tab-nav></shared-messages-tab-nav>
      </template>

      <vs-table hover-flat v-if="callbackNumbers && callbackNumbers.length" :data="callbackNumbers">
        <template slot="thead">
          <vs-th v-text="$t('no')"></vs-th>
          <vs-th v-text="$t('message_callback_number')"></vs-th>
          <vs-th v-text="$t('status')"></vs-th>
          <vs-th class="text-center" v-text="$t('function')"></vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td v-text="tr.count" :data-tr-title="$t('no')"></vs-td>
            <vs-td :data-tr-title="$t('message_callback_number')">
              <span v-if="canSendSms && tr.number.length > 0">
                <a v-if="$stringHelper.contentIsMobile(tr.number)" href="#" @click.prevent="openSendSmsPopup(tr.number)" v-text="tr.number"></a>
                <span v-else v-text="tr.number"></span>
              </span>
              <span v-else v-text="tr.number"></span>
            </vs-td>
            <vs-td :data-tr-title="$t('status')">
              <badge-is-active :is-active="tr.is_active == 1"></badge-is-active>
            </vs-td>
            <vs-td>
              <div class="flex justify-center">
                <vs-button
                  color="success"
                  size="small"
                  v-text="$t('select')"
                  @click.prevent="setCallbackNumberActive(tr.id)"
                  v-if="tr.is_active != 1">
                </vs-button>
                <span v-if="tr.is_active != 1">&nbsp;</span>
                <vs-button
                  color="primary"
                  type="border"
                  icon-pack="feather"
                  icon="icon-edit"
                  size="small"
                  @click="editCallbackNumberPopup(tr.id)">
                </vs-button>
                &nbsp;
                <vs-button
                  color="danger"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-trash-2"
                  size="small"
                  @click="deleteCallbackNumber(tr.id)">
                </vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
        <div v-text="$t('no_record')"></div>
      </vs-alert>

      <template slot="footer" v-if="hasPagination">
        <paginate
          :total="callbackNumberPages"
          :click-handler="loadCallbackNumbers"
          :value="initialPage"
          goto
        >
        </paginate>
      </template>
    </vx-card>

    <modal :title="$t('edit_callback_number')" :active.sync="modals.callback.edit" size="lg" style="z-index: 53001;">
      <div id="EditCallbackNumberFormContainer" class="vs-con-loading__container">
        <shared-messages-callback-numbers-edit
          @editCallbackNumberSuccess="editCallbackNumberSuccess"
        ></shared-messages-callback-numbers-edit>
        <vs-divider></vs-divider>
        <div class="flex justify-end">
          <vs-button id="editCallbackNumberButton" color="primary" type="filled" @click.prevent="updateCallbackNumber">{{ $t('save') }}</vs-button>
        </div>
      </div>
    </modal>

    <modal v-if="canSendSms" :title="'Send Message'" :active.sync="modals.callback.sendMessage" size="xl">
      <shared-send-message></shared-send-message>
    </modal>
  </div>
</template>

<script>
import BadgeIsActive  from '@/components/badge/Active'
import Modal from '@/components/Modal'
import CallbackNumber from '@/models/CallbackNumber'
import SharedSendMessage from '@/views/Shared/Messages/Send'
import SharedMessagesTabNav from '@/views/Shared/Messages/TabNav'
import SharedMessagesCallbackNumbersEdit from '@/views/Shared/Messages/CallbackNumbers/Edit'
import {EventBus} from '@/../eventbus'
import Utils from '@/helpers/utils'

export default {
  name: 'Shared.Messages.CallbackNumbers.List',
  components: {
    BadgeIsActive,
    Modal,
    SharedSendMessage,
    SharedMessagesTabNav,
    SharedMessagesCallbackNumbersEdit
  },
  props: {
    callbackNumbers: {
      type: [Object, Array],
      required: true
    },
    canSendSms: {
      type: Boolean,
      default: false
    },
    showNavTab: {
      type: Boolean,
      default: false
    },
    callbackNumberPages: {
      type: Number,
      default: 1
    }
  },
  computed: {
    hasPagination () {
      return this.callbackNumberPages > 1
    }
  },
  watch: {
    'modals.callback.edit' (val) {
      if (!val) {
        EventBus.$emit('initCallbackNumberResetFormData')
      }
    }
  },
  data () {
    return {
      data: {},
      callbackNumberFormData: {},
      modals: {
        callback: {
          edit: false,
          sendMessage: false
        }
      }
    }
  },
  methods: {
    editCallbackNumber (id) {
      this.modals.callback.edit = true
      EventBus.$emit('initCallbackNumberGetFormData', {id})
    },
    editCallbackNumberPopup (id) {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'edit-callback-number', {id}, this.editCallbackNumber)
    },
    updateCallbackNumber () {
      EventBus.$emit('initUpdateCallbackNumber')
    },
    editCallbackNumberSuccess () {
      this.modals.callback.edit = false
      this.$emit('loadCallbackList')
    },
    async deleteCallbackNumber (id) {
      const confirm = await this.$swalHelper.warning({
        title: this.$i18n.t('are_you_sure_you_want_to_delete'),
        text: this.$i18n.t('after_deletion_recovery_is_not_possible'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })

      if (confirm.value) {
        const response = await CallbackNumber.destroy({ id })

        this.$swalHelper.success({
          title: this.$t('action_success'),
          text: this.$t(response.data),
          confirmButton: this.$t('confirm')
        })

        this.$emit('loadCallbackList')
      }
    },
    async setCallbackNumberActive (id) {
      const confirm = await this.$swalHelper.warning({
        text: this.$t('are_you_sure_you_want_to_set_as_active_the_selected_callback_number'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })

      if (confirm.value) {
        try {
          const response = await CallbackNumber.setCallbackNumberActive({ id })

          this.$swalHelper.success({
            title: this.$t('action_success'),
            text: this.$t(response.data),
            confirmButton: this.$t('confirm')
          })

          this.$emit('loadCallbackList')
        } catch (e) {
          this.$swalHelper.displayCatchError({
            title: 'Error!',
            errorObject: 'User not found',
            confirmButton: this.$t('confirm')
          })
        }
      }
    },
    openSendSmsPopup (number) {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'send-sms', { number }, this.sendSms)
    },
    sendSms (number) {
      EventBus.$emit('setGivenNumber', number)
      this.modals.callback.sendMessage = true
    },
    async addCallbackNumber () {
      this.$vs.loading({background: 'primary', color: '#fff', container: '#addCallbackNumberButton', scale: 0.45})
      try {
        if (!this.$store.getters.isFormInProgress) {
          this.$store.dispatch('setIsFormInProgress', true)
          const response = await CallbackNumber.store(this.callbackNumberFormData)

          this.$swalHelper.success({
            title: this.$t('action_success'),
            text: this.$t(response.data),
            confirmButton: this.$t('confirm')
          })

          this.$store.dispatch('setIsFormInProgress', false)

          this.$emit('loadCallbackList')
          this.resetCallbackNumberForm()
        }
      } catch (e) {
        if (this.callbackNumberFormData.number.trim().length === 0) {
          this.$swalHelper.displayCatchError({
            title: 'Error!',
            errorObject: this.$t('add_message_callback_number_error_message_if_empty_number'),
            confirmButton: this.$t('confirm')
          })
        }
        this.$store.dispatch('setIsFormInProgress', false)
      }
      this.$vs.loading.close('#addCallbackNumberButton > .con-vs-loading')
    },

    resetCallbackNumberForm () {
      this.callbackNumberFormData = {
        number: ''
      }
      this.callbackNumberFormErrors = []
    }
  }
}
</script>

<style lang="scss">
  #addCallbackNumberButton {
    .con-vs-loading {
      position: absolute !important;
    }
  }
</style>
